import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "flex flex-wrap gap-3" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "w-full flex mt-2" }
const _hoisted_5 = { class: "w-full flex flex-wrap gap-3" }
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = { class: "flex flex-wrap pt-3 pr-3 pl-3 pb-2 mt-3 mb-4 gap-3 border-2 border-gray-100 bg-white border-round-xl relative" }
const _hoisted_8 = { class: "flex-1" }
const _hoisted_9 = { class: "flex mb-2" }
const _hoisted_10 = { class: "mx-3" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "flex-1" }
const _hoisted_13 = { class: "flex mb-2" }
const _hoisted_14 = { class: "mx-3" }
const _hoisted_15 = ["textContent"]
const _hoisted_16 = { class: "flex-1" }
const _hoisted_17 = { class: "flex flex-wrap pt-3 pr-3 pl-3 pb-2 mt-3 mb-4 gap-3 border-2 border-gray-100 bg-white border-round-xl relative" }
const _hoisted_18 = { class: "flex-1" }
const _hoisted_19 = { class: "flex mb-2" }
const _hoisted_20 = { class: "mx-3" }
const _hoisted_21 = ["textContent"]
const _hoisted_22 = { class: "flex-1" }
const _hoisted_23 = { class: "flex mb-2" }
const _hoisted_24 = { class: "mx-3" }
const _hoisted_25 = ["textContent"]

import { onMounted, ref } from 'vue';
import Calendar from 'primevue/calendar';
import { useDateTime } from '@/composables';
import { StudentTotalReportService } from '@/services';
import StudentTotalReportDisciplines from './StudentTotalReportDisciplines.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'StudentTotalReport',
  setup(__props) {

const $dateTime = useDateTime();

const filterDate = ref();

const minDate = new Date('2023-12-11 00:00:00');

const maxDate = ref();

const totals = ref({
  total_students_ytd_minutes: 0,
  total_students_all_time_minutes: 0,
  total_students_minutes_ytd_minutes: 0,
  total_students_minutes_all_time_minutes: 0,
  total_students_ytd_discipline: [],
  total_students_all_time_discipline: [],
});

onMounted(() => init());

const init = async () => {
  defineDate();
  getStudentTotals();
};

const defineDate = () => {
  filterDate.value = new Date();
  maxDate.value = new Date();
};

const getStudentTotals = async () => {
  const payload = { date: $dateTime.formatDateForApi(filterDate.value) };
  const response = await StudentTotalReportService.getStudentTotalReport(payload);
  totals.value = response.data.data;
};

const onDateSelect = (value) => {
  filterDate.value = value;
  getStudentTotals();
};

const formatNumber = (number: number) => new Intl.NumberFormat().format(Math.round(number));

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex pt-4" }, [
            _createElementVNode("h2", { textContent: 'Student Total for ' })
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Calendar), {
              modelValue: filterDate.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterDate).value = $event)),
              "show-icon": "",
              "icon-display": "input",
              class: "mt-3 text-sm",
              "date-format": "MM, dd yy",
              "min-date": _unref(minDate),
              "max-date": maxDate.value,
              onDateSelect: onDateSelect
            }, null, 8, ["modelValue", "min-date", "max-date"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Icon, {
                      name: "perm_contact_calendar",
                      class: "text-color-purple text-4xl p-2 bg-purple-light border-round align-self-start"
                    }),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-color-secondary text-base" }, "Students, Year To Date", -1)),
                      _createElementVNode("p", {
                        class: "text-color-purple-dark text-5xl font-bold",
                        textContent: _toDisplayString(formatNumber(totals.value.total_students_ytd_minutes))
                      }, null, 8, _hoisted_11)
                    ]),
                    _withDirectives(_createVNode(_component_Icon, {
                      name: "info",
                      class: "text-gray-400 text-base cursor-pointer align-self-start"
                    }, null, 512), [
                      [
                        _directive_tooltip,
                        `Students served year to date for Sessions, Consultations, and Evaluations`,
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_Icon, {
                      name: "assignment_turned_in",
                      class: "text-color-pink text-4xl p-2 bg-pink-light border-round align-self-start"
                    }),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-color-secondary text-base" }, "Students, Year To Date Minutes", -1)),
                      _createElementVNode("p", {
                        class: "text-color-pink-dark text-5xl font-bold",
                        textContent: _toDisplayString(formatNumber(totals.value.total_students_minutes_ytd_minutes))
                      }, null, 8, _hoisted_15)
                    ]),
                    _withDirectives(_createVNode(_component_Icon, {
                      name: "info",
                      class: "text-gray-400 text-base cursor-pointer align-self-start"
                    }, null, 512), [
                      [
                        _directive_tooltip,
                        `Student year to date minutes for Sessions, Consultations, and Evaluations`,
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ])
                ])
              ]),
              _createVNode(StudentTotalReportDisciplines, {
                title: "Students, Disciplines Year to Date",
                tooltip: "Student year to date totals per disciplines",
                disciplines: totals.value.total_students_ytd_discipline
              }, null, 8, ["disciplines"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Icon, {
                      name: "calendar_today",
                      class: "text-color-blue text-4xl p-2 bg-blue-light border-round align-self-start"
                    }),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-color-secondary text-base" }, "Students, All Time", -1)),
                      _createElementVNode("p", {
                        class: _normalizeClass(`text-color-blue-dark text-5xl font-bold`),
                        textContent: _toDisplayString(formatNumber(totals.value.total_students_all_time_minutes))
                      }, null, 8, _hoisted_21)
                    ]),
                    _withDirectives(_createVNode(_component_Icon, {
                      name: "info",
                      class: "text-gray-400 text-base cursor-pointer align-self-start"
                    }, null, 512), [
                      [
                        _directive_tooltip,
                        `Students served all time for Sessions, Consultations, and Evaluations`,
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_Icon, {
                      name: "assignment_turned_in",
                      class: "text-color-orange text-4xl p-2 bg-orange-light border-round align-self-start"
                    }),
                    _createElementVNode("div", _hoisted_24, [
                      _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-color-secondary text-base" }, "Students, All Time Minutes", -1)),
                      _createElementVNode("span", {
                        class: "text-color-orange-dark text-5xl font-bold",
                        textContent: _toDisplayString(formatNumber(totals.value.total_students_minutes_all_time_minutes))
                      }, null, 8, _hoisted_25)
                    ]),
                    _withDirectives(_createVNode(_component_Icon, {
                      name: "info",
                      class: "text-gray-400 text-base cursor-pointer align-self-start"
                    }, null, 512), [
                      [
                        _directive_tooltip,
                        `Student all time minutes for Sessions, Consultations, and Evaluations`,
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ])
                ])
              ]),
              _createVNode(StudentTotalReportDisciplines, {
                title: "Students, Disciplines All Time",
                tooltip: "Student all time totals per disciplines",
                disciplines: totals.value.total_students_all_time_discipline
              }, null, 8, ["disciplines"])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})